// extracted by mini-css-extract-plugin
export default {"pagination":"_35VXyM3rj3uXmyDzDT1DK8","empty":"_2dbbNd4J-PViklnwWxNpNa","emptyTitle":"_3hlgzbPvZw4rDykh83DPKS"};